import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=e6c71094&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&lang=ts"
export * from "./SubmitForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c71094",
  null
  
)

export default component.exports